import { useMemo } from 'react';
import { Bets ,BetSpotNumber} from '../../../config/bets';

export const useBetSpotMultiplierConnected = (betSpot: Bets): number => {
  return useMemo((): number => {
    return BetSpotNumber[betSpot] || 0;
  }, [ betSpot]);
};
